<template>
  <div>
    <headerSection></headerSection>
    <div id="main__content">
      <div class="x-main-container">
        <div class="x-main-content">
          <div class="x-huay-page" :style="{'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">

            <!-- Page Header -->
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="x-page-title-component">
                    <div class="-inner-wrapper">
                      <div class="-icon-wrapper">
                        <i class="fas fa-ticket-alt"></i>
                      </div>
                      <h1 class="-title">แทงหวยไม่ยั้ง</h1>
                      <div class="-quota-badge">
                        <span class="-current">{{countQTY}}</span>
                        <span class="-separator">/</span>
                        <span class="-total">{{QTY}}</span>
                      </div>
                    </div>
                  </div>
                  <p class="-description">**เงื่อนไขฝากทุกๆ 300 ได้รับสิทธิ์ทันที เฉพาะวันที่หวยออก**</p>
                </div>
              </div>
            </div>

            <!-- Lottery Grid Section -->
            <div class="container">
              <div class="x-huay-grid-wrapper">
                <!-- Top Confirm Button -->
                <div class="x-confirm-section" v-if="isShow">
                  <button type="button"
                          @click="confirm()"
                          :disabled="isDisabled"
                          class="x-btn-confirm-lottery">
                    <i class="fas fa-check-circle"></i>
                    <span>{{buttonLabel}}</span>
                  </button>
                </div>

                <!-- Number Grid -->
                <div class="x-number-grid">
                  <div class="x-number-row" v-for="index in rows" :key="index">
                    <a href="#"
                       :class="['x-number-cell', { '-selected': huays[renderNumber(index, 0)] }]"
                       @click.prevent="selectNumber(renderNumber(index, 0))">
                      <span class="-number">{{renderNumber(index, 0)}}</span>
                    </a>
                    <a href="#"
                       :class="['x-number-cell', { '-selected': huays[renderNumber(index, 1)] }]"
                       @click.prevent="selectNumber(renderNumber(index, 1))">
                      <span class="-number">{{renderNumber(index, 1)}}</span>
                    </a>
                    <a href="#"
                       :class="['x-number-cell', { '-selected': huays[renderNumber(index, 2)] }]"
                       @click.prevent="selectNumber(renderNumber(index, 2))">
                      <span class="-number">{{renderNumber(index, 2)}}</span>
                    </a>
                    <a href="#"
                       :class="['x-number-cell', { '-selected': huays[renderNumber(index, 3)] }]"
                       @click.prevent="selectNumber(renderNumber(index, 3))">
                      <span class="-number">{{renderNumber(index, 3)}}</span>
                    </a>
                    <a href="#"
                       :class="['x-number-cell', { '-selected': huays[renderNumber(index, 4)] }]"
                       @click.prevent="selectNumber(renderNumber(index, 4))">
                      <span class="-number">{{renderNumber(index, 4)}}</span>
                    </a>
                  </div>
                </div>

                <!-- Bottom Confirm Button -->
                <div class="x-confirm-section -bottom" v-if="isShow">
                  <button type="button"
                          @click="confirm()"
                          :disabled="isDisabled"
                          class="x-btn-confirm-lottery">
                    <i class="fas fa-check-circle"></i>
                    <span>{{buttonLabel}}</span>
                  </button>
                </div>

                <!-- Rules Section -->
                <div class="x-rules-card">
                  <p class="-rule-text">**ทุกๆยอดฝาก 300 บาท รับทันที 1 สิทธิ์แทงเลขท้าย 2 ตัวล่าง รัฐบาล แทงถูก!!! รับฟรี 300 บาท ร่วมลุ้นรับรางวัลทุกวันหวยออก**</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <footerSection></footerSection>
    </div>
  </div>
</template>
<script>
import firebase, { database } from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import _ from 'lodash'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'
const axios = require('axios').default
require('vue2-animate/dist/vue2-animate.min.css')
// @ is an alias to /src
export default {
  name: 'Gift',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
        const _user = JSON.parse(user)
        this.$store.dispatch('user/setUser', _user).then(async ()=>{
          const huay = (await firebase.database().ref('/huay').once('value')).val()
          const dateHuay = [];
          for(const x in huay){
            dateHuay.push(Number(huay[x]))
          }
          if(dateHuay.includes(Number(moment().tz("Asia/Bangkok").format('D')))){
              if(Number(moment().tz("Asia/Bangkok").format('H')+''+moment().tz("Asia/Bangkok").format('mm')) <= 1520){
                this.calculate();
                this.isShow = true;
              }else{
                 this.calculate();
              }
            }else{
              this.QTY = 0;
              this.countQTY = 0;
            }
        }).catch(err => { console.error(err) })
    } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
    }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  mounted () {
  },
  data () {
    return {
      isShow: false,
      huays:[],
      rows:20,
      logoLeft: '',
      logoRight: '',
      angle: 0,
      gameKey: 'spin',
      showLoading: true,
      pictureUrl: '',
      code: '',
      games_web: [],
      search: '',
      loading: false,
      error: false,
      web: [],
      message: 'Invalid user name or password!',
      point: 0,
      favorites: [],
      animationInfinite: {
        classes: 'fadeIn',
        duration: 5000,
        iteration: 'infinite'
      },
      buttonLabel:'ยืนยันแทงหวย',
      permission: [],
      defaultOptions: null,
      defaultOptions2: null,
      defaultOptionsSplashScreen: null,
      openGiftData: false,
      canOpen: false,
      percentage: 0,
      loadingtext: '',
      credit: '',
      save: false,
      canvas: null,
      frame: null,
      wheels: null,
      sections: [],
      sectionspoint: [],
      colors: [],
      percent: [],
      isDisabled: false,
      QTY:'loading',
      countQTY:'loading',
    }
  },
  methods: {
    calculate(){
        firebase.firestore().collection('krungsri').where('date', '>=', moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 00:00:00').where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('userkey','==',this.user.key).get().then((snapshot)=>{
            let deposit = 0;
            snapshot.forEach((doc)=>{
                deposit += (Number(doc.data().qty.toString().replace(',','')));
            });
            const qty = Math.floor(deposit/300);
            this.QTY = qty;
            if(qty){
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then((doc)=>{
                if(doc.exists){
                    if(doc.data().huays){
                        for(const x in doc.data().huays){
                            const xx = doc.data().huays[x];
                            this.huays[xx] = true;
                        }
                        this.countQTY = doc.data().huays.length;
                    }
                }else{
                    this.countQTY = 0;
                }
            });
            }
    });
    },
    selectNumber(num){
        if(typeof this.countQTY == 'number' && typeof this.QTY == 'number' && this.isShow){
            if(this.huays[num]){
                delete this.huays[num]
                this.countQTY--
            }else if(this.QTY > this.countQTY){
                this.huays[num] = true
                this.countQTY++
            }
            this.rows++;
            this.rows--;
        }
    },
    async confirm() {
        if(Object.keys(this.huays).length <= this.QTY && this.QTY > 0){
            this.buttonLabel = 'loading...';
            this.isDisabled = true;
            const huays = [];
            let lotto = '';
            for(const x in this.huays){
                if(this.huays[x]){
                    huays.push(x);
                    lotto += (lotto)?', '+x:x;
                }
            }
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format('YYYY-MM-DD')).set({
                huays,
                userkey: this.user.key,
                updatetime: moment().tz("Asia/Bangkok").format('YYYY-MM-DD HH:mm:ss'),
                date: moment().tz("Asia/Bangkok").format('YYYY-MM-DD'),
                code:this.user.code,
            }).then(async ()=>{
                this.isDisabled = false;
                this.buttonLabel  = 'ยืนยันแทงหวย';
                this.$confirm(
                    {
                        message: `แทงหวยเรียบร้อยแล้วค่ะ 😘`,
                        button: {
                            yes: 'OK'
                        },
                        callback: confirm => {
                        if (confirm) {

                            // this.getUserId()
                        }
                        }
                    }
                )
            });
        }else{
          alert('โปรดตรวจสอบสิทธิ์จำนวนที่แทง');
        }
    },
    renderNumber(row,i){
        const num = ((row-1)*5)+i;
        if(num.toString().length == 1){
            return '0'+num;
        }else{
            return num.toString();
        }
    },
    async getGames () {
      this.games_web = (await firebase.database().ref('/spin').once('value')).val()
    },
    checkCssBox (game) {
      if (!game.status) {
        return 'box-shadow: 0 0 12px 5px #cccccc;border: 2px solid #cccccc;'
      }
    },
    checkCss (game) {
      if (!this.permission || !this.permission[game.key]) {
        return 'filter: grayscale(100%);'
      }
    },
    goto (type) {
      if (type === 'home') {
        this.$router.push('/').catch(() => {})
      } else if (type === 'website') {
        window.location = this.web.link
      } else if (type === 'contact') {
        window.location = this.web.link_line
      }
    },
  }
}
</script>
<style scoped>
/* Page Container */
.x-huay-page {
  min-height: 100vh;
  padding: 20px 0 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Page Title */
.x-page-title-component {
  padding: 20px 0;
}

.x-page-title-component .-inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.x-page-title-component .-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ffe867 10%, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.x-page-title-component .-icon-wrapper i {
  font-size: 22px;
  color: #1b1b41;
}

.x-page-title-component .-title {
  font-family: 'Kanit', sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.x-page-title-component .-quota-badge {
  background: linear-gradient(180deg, #101025, #101027);
  border: 2px solid #fec33f;
  border-radius: 25px;
  padding: 8px 20px;
  font-family: 'Kanit', sans-serif;
  box-shadow: 0 0 15px rgba(254, 195, 63, 0.3);
}

.x-page-title-component .-quota-badge .-current {
  color: #4ade80;
  font-size: 18px;
  font-weight: 600;
}

.x-page-title-component .-quota-badge .-separator {
  color: #ffc107;
  margin: 0 5px;
}

.x-page-title-component .-quota-badge .-total {
  color: #ffc107;
  font-size: 18px;
  font-weight: 600;
}

.-description {
  text-align: center;
  color: #e0e0e0;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 0;
}

/* Grid Wrapper */
.x-huay-grid-wrapper {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid #fec33f;
  border-radius: 20px;
  padding: 25px;
  margin-top: 20px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.2);
}

/* Confirm Section */
.x-confirm-section {
  text-align: center;
  margin-bottom: 25px;
}

.x-confirm-section.-bottom {
  margin-top: 25px;
  margin-bottom: 0;
}

.x-btn-confirm-lottery {
  background: linear-gradient(180deg, #4ade80 10%, #22c55e);
  border: none;
  border-radius: 30px;
  padding: 15px 50px;
  font-family: 'Kanit', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(74, 222, 128, 0.4);
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.x-btn-confirm-lottery:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 6px 25px rgba(74, 222, 128, 0.6);
}

.x-btn-confirm-lottery:disabled {
  background: linear-gradient(180deg, #6b7280, #4b5563);
  cursor: not-allowed;
  box-shadow: none;
}

.x-btn-confirm-lottery i {
  font-size: 20px;
}

/* Number Grid */
.x-number-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.x-number-row {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.x-number-cell {
  width: 60px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #1e1e4a, #101027);
  border: 2px solid rgba(254, 195, 63, 0.3);
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.x-number-cell .-number {
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.x-number-cell:hover {
  border-color: #fec33f;
  transform: scale(1.05);
  box-shadow: 0 0 15px rgba(254, 195, 63, 0.3);
}

.x-number-cell.-selected {
  background: linear-gradient(180deg, #fec33f, #fe8a02);
  border-color: #ffe867;
  animation: x-neon-gold 0.8s ease-in-out infinite alternate;
}

.x-number-cell.-selected .-number {
  color: #1b1b41;
}

/* Rules Card */
.x-rules-card {
  margin-top: 25px;
  padding: 20px;
  background: rgba(254, 195, 63, 0.1);
  border: 1px dashed #fec33f;
  border-radius: 15px;
}

.x-rules-card .-rule-text {
  text-align: center;
  color: #ffc107;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
}

/* Neon Animation */
@keyframes x-neon-gold {
  0% {
    box-shadow: 0 0 5px #fff, 0 0 10px #ffdc73, 0 0 15px #ffdc73;
  }
  100% {
    box-shadow: 0 0 2px #fff, 0 0 5px #ffdc73, 0 0 8px #ffdc73;
  }
}

/* Responsive */
@media (max-width: 576px) {
  .x-number-cell {
    width: 52px;
    height: 44px;
  }

  .x-number-cell .-number {
    font-size: 14px;
  }

  .x-number-row {
    gap: 5px;
  }

  .x-huay-grid-wrapper {
    padding: 15px;
    margin-left: -5px;
    margin-right: -5px;
  }

  .x-page-title-component .-title {
    font-size: 18px;
  }

  .x-page-title-component .-quota-badge {
    padding: 6px 15px;
  }

  .x-page-title-component .-quota-badge .-current,
  .x-page-title-component .-quota-badge .-total {
    font-size: 16px;
  }

  .x-btn-confirm-lottery {
    padding: 12px 35px;
    font-size: 16px;
  }
}

@media (max-width: 380px) {
  .x-number-cell {
    width: 48px;
    height: 40px;
  }

  .x-number-cell .-number {
    font-size: 13px;
  }

  .x-number-row {
    gap: 4px;
  }
}
</style>
